const partners = {
  permissionSource: 'api::partner.partner',
  creationTitle: 'Create Partner',
  creationEndPoint: '/partners',
  detailTitle: 'Partner: :title',
  detailEndPoint:
    '/partners/:id?populate[0]=logo&populate[1]=tel&populate[2]=fax&populate[3]=whatsapp&populate[4]=address&populate[5]=address.region&populate[6]=parent_company&populate[7]=subsidiary&populate[8]=partner_type&populate[9]=partner_channel&populate[10]=contact_people',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Partner Code',
              required: true,
            },
            {
              label: 'Name',
              value: 'name',
              tag: 'input',
              type: 'text',
              placeholder: 'Partner Name',
              required: true,
            },
            {
              label: 'Email',
              value: 'email',
              tag: 'input',
              type: 'email',
              placeholder: 'Partner Email',
            },
            {
              label: 'Blacklisted',
              value: 'blacklisted',
              tag: 'switch',
            },
            {
              label: 'Website',
              value: 'website',
              tag: 'input',
              type: 'text',
              placeholder: 'Partner Website URL',
            },
            {
              label: 'Parent Company',
              value: 'parent_company',
              tag: 'single-select',
              dataSourceUrl: '/partners',
              dataLabel: 'name',
            },
            {
              label: 'Subsidiaries',
              value: 'subsidiary',
              tag: 'multi-select',
              dataSourceUrl: '/partners',
              dataLabel: 'name',
            },
            {
              label: 'BR Number',
              value: 'br_number',
              tag: 'input',
              type: 'text',
              placeholder: 'XXXXXXXX-XXX-XX-XX-X',
            },
            {
              label: 'Number of Staff',
              value: 'number_of_staff',
              tag: 'input',
              type: 'number',
            },
            {
              label: 'Date of Establishment',
              value: 'date_of_establishment',
              tag: 'date-picker',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Logo',
              value: 'logo',
              tag: 'media',
              acceptFile: 'image/*',
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Telephone',
                  value: 'tel.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'tel.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'tel.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Mobile',
                  value: 'mobile.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'mobile.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'mobile.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Fax',
                  value: 'fax.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'fax.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'fax.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'WhatsApp',
                  value: 'whatsapp.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'whatsapp.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'whatsapp.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              label: 'Partner Type',
              value: 'partner_type',
              tag: 'single-select',
              dataSourceUrl: '/partner-types',
              dataLabel: 'title',
            },
            {
              label: 'Partner Channel',
              value: 'partner_channel',
              tag: 'single-select',
              dataSourceUrl: '/partner-channels',
              dataLabel: 'title',
            },
            {
              label: 'Contact People',
              value: 'contact_people',
              tag: 'multi-select',
              dataSourceUrl: '/contact-people',
              dataLabel: 'name',
            },
          ],
        },
      ],
    },
    {
      label: 'Address',
      value: 'address.address_line_1',
      placeholder: 'Address Line 1',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'address.address_line_2',
      placeholder: 'Address Line 2',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'address.address_line_3',
      placeholder: 'Address Line 3',
      tag: 'input',
      type: 'text',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Country',
          value: 'address.country',
          tag: 'input',
          type: 'text',
        },
        {
          label: 'Region',
          value: 'address.region',
          tag: 'single-select',
          dataSourceUrl: '/regions',
          dataLabel: 'name',
        },
        {
          label: 'Zip',
          value: 'address.zip',
          tag: 'input',
          type: 'text',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Credit',
          value: 'credit',
          placeholder: 'Credit amount',
          tag: 'input',
          type: 'number',
        },
        {
          label: 'Paid',
          value: 'paid',
          placeholder: 'Paid amount',
          tag: 'input',
          type: 'number',
        },
        {
          label: 'Advance',
          value: 'advance',
          placeholder: 'Advance amount',
          tag: 'input',
          type: 'number',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default partners
